import React, { Component } from "react";
import { connect } from "react-redux";

//Auth
import { doLogOut } from "./../firebase/auth";
import * as ACTIONS from "../actions";

//Router
import * as ROUTE from "../routes";
import { push, goBack } from "react-router-redux";

//MUI
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Toolbar from "@material-ui/core/Toolbar";

import { withStyles } from "@material-ui/core/styles";

//Icons
import BrandIcon from "../static/Icons/tapaIcon.png";
// import BrandIcon from "../static/Icons/lynx.png";

import PersonIcon from "@material-ui/icons/Person";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import { isLoaded, isEmpty } from "react-redux-firebase";
import { CircularProgress } from "@material-ui/core";

class Navigation extends Component {
  state = {
    anchorEl: null,
    itemSelected: null
  };

  render() {
    const { classes, auth, location, profile, reroute } = this.props;
    const { anchorEl } = this.state;

    const open = Boolean(anchorEl);

    const logOutHandler = () => {
      this.handleUserMenuClose();
      reroute(ROUTE.LANDING);
      this.props.resetApp();
      doLogOut();
    };

    const handleBack = () => {
      this.props.backButton();
    };

    let logo = BrandIcon;
    if (isLoaded(profile) && !isEmpty(profile) && profile.whitelabel) {
      logo = profile.whitelabel.icon ? profile.whitelabel.icon : BrandIcon;
    }

    return (
      <div className={classes.root}>
        {/* AppBar Logic */}
        <AppBar position="fixed" className={classes.appBar}>
          <Toolbar style={{ justifyContent: "space-between" }}>
            {/* Brand */}
            {location.pathname.startsWith("/point") ? (
              <IconButton
                aria-owns={open ? "menu-appbar" : null}
                aria-haspopup="true"
                onClick={() => handleBack()}
                color="inherit"
                style={{ border: "1px solid #ccc" }}
              >
                <KeyboardArrowLeftIcon />
              </IconButton>
            ) : !isLoaded(profile) ? (
              <CircularProgress size={20} />
            ) : (
              <div
                className={classes.imgWrapper}
                onClick={() => reroute(ROUTE.DASHBOARD)}
              >
                <img
                  src={logo}
                  alt={"logo"}
                  height={"100%"}
                  style={{ cursor: "pointer" }}
                />
              </div>
            )}

            {auth && location.pathname !== "/" ? (
              <IconButton
                size="small"
                aria-owns={open ? "menu-appbar" : null}
                aria-haspopup="true"
                onClick={this.handleUserMenuOpen}
                color="inherit"
              >
                <PersonIcon className={classes.iconColor} />
              </IconButton>
            ) : null}

            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right"
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right"
              }}
              open={open}
              onClose={this.handleUserMenuClose}
            >
              {/* ./Navigation/UserMenu */}
              <div style={{ outline: "none", fontVariant: "all-petite-caps" }}>
                {/* <MenuItem onClick={() => this.handleRoute(ROUTE.PROFILE)}>
                  profile
                </MenuItem> */}
                <MenuItem onClick={() => reroute(ROUTE.PROFILE)}>
                  Profile
                </MenuItem>
                <MenuItem onClick={() => logOutHandler()}>logout</MenuItem>
              </div>
            </Menu>
          </Toolbar>
        </AppBar>
        <div className={classes.toolbar} />
      </div>
    );
  }

  // SignInDialog Handlers
  handleRoute = route => {
    this.props.reroute(route);
    this.setState({ anchorEl: null });
  };

  //UserMenu Handlers
  handleUserMenuOpen = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleUserMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  handleMenuItemClick = item => {
    const { itemSelected } = this.state;
    this.setState({ itemSelected: itemSelected === item ? null : item });
  };
}

//Styles
const styles = theme => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.down("xs")]: {
      marginBottom: 56
    },
    [theme.breakpoints.up("sm")]: {
      marginBottom: 64
    }
  },
  appBar: {
    boxShadow: "none",
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.getContrastText(theme.palette.primary.main)
  },
  typography: {
    flex: 1,
    textAlign: "center",
    // paddingLeft: "1em",
    cursor: "pointer"
  },
  toolbar: {},
  imgWrapper: {
    display: "flex",
    alignItems: "center",
    borderRadius: 4,
    height: 40
  },
  profileButton: {
    background: "white",
    boxShadow: theme.shadows[3],
    color: theme.palette.secondary.main
  },
  iconColor: {
    color: theme.palette.primary.main
  }
});

//Connect
const mapStateToProps = state => ({
  auth: state.firebase.auth,
  profile: state.firebase.profile,
  location: state.router.location
});

const mapDispatchToProps = dispatch => ({
  reroute: target => dispatch(push(target)),
  backButton: () => dispatch(goBack()),
  resetApp: () =>
    dispatch({
      type: ACTIONS.RESET_APP
    })
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Navigation));
